const Joi = require('joi')
const fields = require('../fields')

const getAuthRequestSchema = Joi.object({
    requestId: fields.objectIdField.required().label('Auth Request ID'),
});

module.exports = getAuthRequestSchema;